import { ZoomIn } from 'lucide-react';
import { useSubscription } from '@rta/rta-blueprint-library';

import { Controller } from '@context';
import { ControllerAutoZoomSupport } from './types';
import { lang } from '@lang';
import { useDesign } from '@hooks';
import { Feature, FeatureHoookParams } from '..';

type ZoomInFeatureParams = FeatureHoookParams;
export const useZoomInFeature = (_params: ZoomInFeatureParams = {}): Feature<number> => {
	const [controller] = useDesign<Controller, ControllerAutoZoomSupport>();

	useSubscription(controller, false, [['viewport-config', 'updated']]);

	const controllerSupportsAutozoomFeature = (controller?.viewport?.config?.autoZoom ?? null) !== null;
	const autozoom = controllerSupportsAutozoomFeature ? controller?.viewport?.config?.autoZoom ?? false : false;

	const [enabled, tooltip] = (() => {
		if (autozoom) return [false, lang.zoom.message.disabled4AutoZoom];
		if (!controller || controller.viewport.config.zoom >= controller.viewport.config.maxZoom) return [false, lang.zoom.message.maxZoomAcheived];
		return [true, lang.zoom.tooltip.zoomIn];
	})();

	return {
		name: 'zoomIn',
		label: lang.zoom.tooltip.zoomIn,
		shortcut: '',
		tooltip,
		icon: (props = {}) => <ZoomIn {...props} />,
		disabled: !enabled,
		value: controller?.viewport?.config?.zoom ?? 1,
		hidden: false,
		handler: () => {
			if (controller && controller.viewport) {
				const newZoom = (controller.viewport.state.targetZoom ?? 1) + controller.viewport.config.zoomStep;
				console.log('newZoom', newZoom);
				controller.viewport.actions.smoothZoom(newZoom);
				// controller.viewport.updateConfig({ zoom: newZoom > controller.viewport.config.maxZoom ? controller.viewport.config.maxZoom : newZoom });
			}
		}
	};
};
